import { createDecorator } from 'vue-class-component';

export const Meta = createDecorator((componentOptions, key) => {
  if (componentOptions.methods) {
    componentOptions.metaInfo = componentOptions.methods[key];
  }
});
